import styled from 'styled-components';
import { subtitle2, heading1, heading4, colors, spacing, fontSizes, fontWeights } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const GoalPerformanceWrapper = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const GoalPerformanceMetricsWrapper = styled.div`
  display: flex;
  padding: ${pxToRem(26)} ${spacing.plusHalf};
`;

export const GoalPerformanceGraphSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GoalPerformanceGraphHeader = styled.div`
  ${heading4}
  margin: ${pxToRem(27)} ${spacing.plusHalf} 0;
  color: ${colors.grey80};
`;

export const PerformanceMetricWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
`;

export const MetricTitle = styled.div`
  ${subtitle2};
  color: ${colors.secondaryText};
  padding-left: ${pxToRem(2)};
  display: flex;
  align-items: center;
  height: ${spacing.half};
`;

export const MetricValue = styled.div`
  ${heading1};
  color: ${colors.grey90};
  padding: ${spacing.half} 0;
`;

export const ChartWrapper = styled.div`
  margin: ${spacing.plusHalf};
`;

export const TooltipDate = styled.div`
  padding: ${spacing.eighth};
`;

export const TooltipCompletions = styled.div`
  padding: ${spacing.eighth};
`;

export const HelpIconWrapper = styled.span`
  padding-left: ${spacing.half};
`;

export const PeriodReportingWrapper = styled.div`
  font-size: ${fontSizes.s14};
  display: flex;
  align-items: center;
`;

export const EmptyPeriodReportingWrapper = styled(PeriodReportingWrapper)`
  color: ${colors.grey50};
  border-bottom: 1px dashed ${colors.grey50};
  width: ${pxToRem(221)};
`;

export const PeriodText = styled(PeriodReportingWrapper)`
  color: ${colors.secondaryText};
  border-bottom: 1px dashed ${colors.secondaryText};
  width: ${pxToRem(134)};
  margin-left: ${spacing.half};
`;

type PeriodIconWrapperProps = {
  backgroundColor: string;
};

export const PeriodIconWrapper = styled.div<PeriodIconWrapperProps>`
  height: ${spacing.plusHalf};
  width: ${spacing.plusHalf};
  border-radius: ${spacing.threeQuarter};
  display: flex;
  align-items: center;
  flex-direction: center;
  margin-right: ${spacing.half};
  background-color: ${(props) => props.backgroundColor};
`;

export const Dash = styled.div`
  background-color: ${colors.grey80};
  width: ${spacing.half};
  height: ${spacing.eighth};
  margin: auto;
  border-radius: ${spacing.quarter};
`;

type PeriodPercentWrapperProps = {
  color: string;
};

export const PeriodPercentWrapper = styled.div<PeriodPercentWrapperProps>`
  color: ${(props) => props.color};
  font-weight: ${fontWeights.bold};
`;
